export default __webpack_public_path__ + "static/media/ic_credit_card.e7ace973.svg";